export default "__VITE_ASSET__c0748ae6__"